import {RestResource} from '../rest'

import {ORGANIZATION_SERVER} from '../server'

const qualificationRole = new RestResource({server: ORGANIZATION_SERVER, resource: 'qualificationRole'});

export default qualificationRole;